export const primary = '#e2007a'
export const secondary = '#c7006c'
export const headerBg = '#3b0899'
export const footerBg = '#470fac'
export const black = '#0f0f1e'
